import React from "react";
import { bp } from "../slug";
import { Link } from "react-router-dom";
import { Shell } from "../Shell";
import { StateView, useLoad } from "../ui";
import { Cat, CatIcon } from "./Explorer";
import { useMode } from "./Playground";

const when = (s: string | null) => (s ? new Date(s).toLocaleDateString("en-AU", { day: "numeric", month: "short" }) : "-");

export default function Portfolio() {
  const m = useMode();
  const { data, error, reload } = useLoad<any>(`/portfolio?mode=${m}`);
  return (
    <Shell crumb="All builds">
      <div className="x-head"><div className="x-title"><span className="x-hero"><CatIcon cat="build" size={22} /></span><div><small className="x-kicker">Every build you can see, read-only</small><h1 data-testid="screen-title">All builds</h1></div></div>
        {data && <div className="pf-counts" data-testid="portfolio-counts"><span><b className="e4-mono">{data.counts.total}</b> builds</span><span><b className="e4-mono needs">{data.counts.waiting}</b> waiting on someone</span><span><b className="e4-mono">{data.counts.handed_over}</b> handed over</span></div>}</div>
      {!data ? <StateView error={error} retry={reload} /> : data.builds.length === 0 ? <div className="emptyline" data-testid="portfolio-empty">Nothing to show yet.</div> : <>
        <Cat cat="build" />
        <div className="pf-table" role="table" data-testid="portfolio-table">
          {data.builds.map((b: any) => <Link key={b.id} to={`${bp(b.id)}/build`} className={`pf-row ${b.waiting_on ? "needs" : ""}`} role="row" data-testid={`portfolio-row-${b.id}`}>
            <span className="pf-org"><small>{b.organisation}</small><b>{b.programme}</b></span>
            <span className="pf-build e4-mono">Build {b.build_no}</span>
            <span className="x-status" data-testid={`portfolio-status-${b.id}`}>{b.status}{b.waiting_on ? <em> · waiting on {b.waiting_on}</em> : null}</span>
            <span className="x-right">{when(b.last_activity)}</span>
          </Link>)}
        </div></>}
    </Shell>
  );
}
